export const reviewLiterals = {
  noResultTitle: { key: 'tasks_review_no_result_title', fallback: { en: 'Nothing to review yet' } },
  noResultHint: {
    key: 'tasks_review_no_result_hint',
    fallback: {
      en: 'The assignee has not submitted a result for this subtask yet. You can review it and leave comments once a result is available.',
    },
  },
  filter: { key: 'filter_btn', fallback: { en: 'Filter' } },
  clear: { key: 'search_feed_filter_clear_button', fallback: { en: 'Clear all' } },
  category: { key: 'category', fallback: { en: 'Category' } },
  contexts: { key: 'contexts', fallback: { en: 'Assignees' } },
  loading: { key: 'dashboard_export_excel_button_loading', fallback: { en: 'Loading data…' } },
  bySubtask: { key: 'tasks_review_by_subtask', fallback: { en: 'By subtask' } },
  byCategory: { key: 'tasks_review_by_category', fallback: { en: 'By category' } },
  show: { key: 'show', fallback: { en: 'Show' } },
  subtasks: { key: 'subtasks', fallback: { en: 'Subtasks' } },
  hint: {
    key: 'tasks_review_filter_hint',
    fallback: { en: 'Applies to every context in this task.' },
  },
  empty: { key: 'search_feed_no_results', fallback: { en: 'No results' } },
  switchContext: { key: 'tasks_review_switch_context', fallback: { en: 'Switch context' } },
  previousContext: { key: 'tasks_review_previous_context', fallback: { en: 'Previous context' } },
  nextContext: { key: 'tasks_review_next_context', fallback: { en: 'Next context' } },
  loadFailed: {
    key: 'tasks_review_load_failed',
    fallback: { en: 'Could not load the next context. Your current context is still open.' },
  },
} as const
